import { render, staticRenderFns } from "./ServiciosFAQ.vue?vue&type=template&id=69d992be&scoped=true"
import script from "./ServiciosFAQ.vue?vue&type=script&lang=js"
export * from "./ServiciosFAQ.vue?vue&type=script&lang=js"
import style0 from "./ServiciosFAQ.vue?vue&type=style&index=0&id=69d992be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d992be",
  null
  
)

export default component.exports